import React, { useState, useEffect } from 'react';
import { View, Text, StyleSheet, useWindowDimensions, TouchableOpacity } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { useIsFocused } from '@react-navigation/native';
import YoutubePlayer from '../../components/youtubePlayer/youtubePlayer';
import ajax from '../../helpers/ajaxHelper';
import Urls from '../../services/Urls';
import { navigate } from '../../navigation/RootNavigation';
import { SHADOWS } from '../../constants/theme';

const MediaVideoHub = (props) => {
  const [posts, setPosts] = useState([]);
  const focus = useIsFocused();
  const { width } = useWindowDimensions();
  const isMobile = width <= 767;

  useEffect(() => {
    ajax
      .get(Urls.GET_POST + 'VIDEO')
      .then(({ data }) => {
        if (data.status) {
          const mData = data?.data?.mediahub || data?.payload;
          if (mData && mData?.length) {
            setPosts(mData);
          }
        }
      })
      .catch((error) => {
        console.log('error fetching video posts', error);
      });
  }, [focus]);

  if (!posts || posts.length === 0) {
    return null;
  }

  return (
    <View style={styles.container}>
      <Text style={styles.sectionHeaderTitle}>Featured Videos</Text>
      <View style={styles.gridWrap}>
        {posts.map((data, index) => (
          <View
            key={`video-${index}`}
            style={[styles.videoCard, { width: isMobile ? '100%' : '48.5%' }]}
          >
            <View style={styles.playerWrap}>
              <YoutubePlayer url={data.video_id} height={190} width={'100%'} />
            </View>
            <View style={styles.cardBody}>
              <View style={styles.textGroup}>
                <Text style={styles.videoTitle} numberOfLines={2}>
                  {data.title || 'Landlord Video Guide'}
                </Text>
                {data.desc ? (
                  <Text style={styles.videoDesc} numberOfLines={2}>
                    {data.desc}
                  </Text>
                ) : null}
              </View>

              <TouchableOpacity
                style={styles.watchBtn}
                onPress={() => {
                  navigate('MediaVideoDetails', { data: data.id });
                }}
                activeOpacity={0.8}
              >
                <Ionicons name="play-circle-outline" size={16} color="#6C2BD9" />
                <Text style={styles.watchBtnText}>Watch Full Video</Text>
              </TouchableOpacity>
            </View>
          </View>
        ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    marginTop: 24,
    marginBottom: 20,
  },
  sectionHeaderTitle: {
    fontSize: 20,
    fontWeight: '700',
    color: '#111827',
    marginBottom: 16,
  },
  gridWrap: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 16,
    width: '100%',
  },
  videoCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    borderWidth: 1,
    borderColor: '#F3F4F6',
    overflow: 'hidden',
    marginBottom: 16,
    height: 370,
    ...SHADOWS.sm,
  },
  playerWrap: {
    width: '100%',
    height: 190,
    backgroundColor: '#000',
  },
  cardBody: {
    padding: 16,
    height: 180,
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  textGroup: {
    flex: 1,
  },
  videoTitle: {
    fontSize: 16,
    fontWeight: '700',
    color: '#111827',
    lineHeight: 22,
    marginBottom: 6,
  },
  videoDesc: {
    fontSize: 13,
    color: '#6B7280',
    lineHeight: 19,
  },
  watchBtn: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    backgroundColor: '#F0E8FF',
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderRadius: 20,
    alignSelf: 'flex-start',
    marginTop: 'auto',
  },
  watchBtnText: {
    fontSize: 12,
    fontWeight: '700',
    color: '#6C2BD9',
  },
});

export default MediaVideoHub;
